import { defineComponent } from "@/utils/define-component";

export default defineComponent((initValue) => ({
  value: initValue,

  increase() {
    this.value++;

    setTimeout(() => {
      this.$refs.input.dispatchEvent(new Event("input", { bubbles: true }));
      this.$refs.input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  },

  decrease() {
    this.value--;

    setTimeout(() => {
      this.$refs.input.dispatchEvent(new Event("input", { bubbles: true }));
      this.$refs.input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  },
}));
